import client from '@/services/';

const state = () => ({
    all: [],
    one: [],
    societe: [],
    attestation: []
});

const getters = {
    all: state => state.all,
    one: state => state.one,
    societe: state => state.societe,
    attestation: state => state.attestation,
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_SOCIETE: (state, obj) => {
        state.societe = obj;
    },
    SET_ATTESTATION: (state, obj) => {
        state.attestation = obj;
    }
};

const actions = {
    async getAll(cxt) {
        let data = await client.get('/cotisation');
        cxt.commit("SET_ALL", data.data);
        return data;
    },
    async getAllConnecteeSociete(cxt) {
        let data = await client.get('/cotisation/societe');
        cxt.commit("SET_SOCIETE", data.data);
        return data;
    },
    async getAllConnectee(cxt) {
        let data = await client.get('/cotisation/personne_physique');
        cxt.commit("SET_ONE", data.data);
        return data.data;
    },
    async mesAttestation(cxt) {
        let data = await client.get('/attestation/connected');
        cxt.commit("SET_ATTESTATION", data.data);
        return data.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
